import AnimatedLine, { AnimatedLineConfig } from "./AnimatedLine";

const config: AnimatedLineConfig = {
    viewBox: "0 0 847 521",
    path: "M0.0683594 520.5C374.982 468.743 395.357 -14.663 846.068 0.864027",
    dots: [
        { cx: 351.068, cy: 286.395, r: 12, delay: 0.8 },
        { cx: 600, cy: 54.612, r: 12, delay: 1.2 },
    ],
    gradient: { x: 423.069, y1: 0.498047, y2: 520.5 },
};

const Line3 = ({ className }: { className?: string }) => (
    <AnimatedLine {...config} className={className} />
);

export default Line3;
